import { connect } from 'react-redux';

import { selectMetricDataForContentItem } from '../selectors';
import { AppState } from '../../app/state/AppState';
import { MapStateToProps } from '../../app/utils/ConnectUtils';
import { MetricCard, MetricCardOwnProps, MetricCardStateProps } from './MetricCard';


const mapStateToProps: MapStateToProps<MetricCardStateProps> = (state: AppState, ownProps: MetricCardOwnProps) => {
  return {
    metricData: selectMetricDataForContentItem(state, ownProps.content),
  };
};

export const ConnectedMetricCard: React.ComponentClass<MetricCardOwnProps> = connect(mapStateToProps, undefined)(MetricCard);
